"use client";

import type { OrganizationsControllerFindAll200 } from "@dc/gateway-jsonapi";
import { organizationsControllerFindAll } from "@dc/gateway-jsonapi";
import { useInfiniteQuery } from "@tanstack/react-query";

const DEFAULT_PAGE_SIZE = 10;

export type Organization = OrganizationsControllerFindAll200["data"][number];

interface UseOrganizationsInfiniteOptions {
  search?: string;
  pageSize?: number;
  include?: string;
}

export function useOrganizationsInfinite({
  search,
  pageSize = DEFAULT_PAGE_SIZE,
  include,
}: UseOrganizationsInfiniteOptions = {}) {
  return useInfiniteQuery({
    queryKey: ["organizations", "infinite", search, pageSize, include],
    queryFn: async ({ pageParam = 1 }) => {
      const params = {
        page: {
          number: pageParam,
          size: pageSize,
        },
        sort: "name",
        ...(include ? { include } : {}),
        ...(search ? ({ filter: { name: { contains: search } } } as unknown as Record<string, unknown>) : {}),
      };
      return organizationsControllerFindAll(params);
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const currentPage = lastPage.meta?.page ?? 1;
      const totalPages = lastPage.meta?.totalPages ?? 1;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
  });
}
